import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {},
  formLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500,
    whiteSpace:'nowrap'
  },
  textField: {
    marginTop: "8px",
    background: 'white',
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  placeholder: {
    color: theme.palette.grey.grey400,
    fontSize: '16px',
    lineHeight: '23px',
    letterSpacing: '0.15px',
  },
  inputBlock: {
    marginBottom: '13px',
  },
  formContainer: {
    [`${theme.breakpoints.up("sm")}`]: {
      display: "flex",
      flexDirection: "column",
    },
  },
}));

export default useStyles;
